import React, { FC } from 'react';
import './returned-notifications.scss';
import CmsTableWithPrint from 'mixins/ui/cms-table-with-print/cms-table-with-print';

const ReturnedNotificationsResponse: FC = (props) => {
    const columns = [
        {
            title: props.config.taxpayerCode,
            dataIndex: 'iinBin',
            key: 'iinBin',
        },
        {
            title: props.config.fullName,
            dataIndex: 'fullName',
            key: 'fullName',
        },
        {
            title: props.config.documentName,
            dataIndex: 'documentName',
            key: 'documentName',
        },
        {
            title: props.config.date,
            dataIndex: 'date',
            key: 'date',
        },
    ];

    return (
        <CmsTableWithPrint
            withoutScroll={true}
            columns={columns}
            data={props.data}
            params={props.params}
            apiUrl="/services/isnaportalsync/open-api/returned-notifications"
            translations={props.translations}
        />
    );
};

export default ReturnedNotificationsResponse;
